export default __webpack_public_path__ + "static/media/profile-picture-3.5eb120b2.jpg";